import request from '@/utils/request'
import { fileService } from "@/api/common/file-utils";
export default {
    getList: (data) => {
        return request({
            url: 'potentialSupplier/searchPotentialSupplier',
            method: 'post',
            data: data,
        })
    },
    resourceList: (data) => {
        return request({
            url: 'supplierResource/searchSupplierResource',
            method: 'post',
            data: data,
        })
    },
    potentialSupplierDetail: (tmSupplierId) => {
        return request({
            url: `potentialSupplier/potentialSupplierDetail/${tmSupplierId}`,
            method: 'GET',
        })
    },
    saveSupplier: (data) => {
        return request({
            url: 'potentialSupplier/savePotentialSupplier',
            method: 'post',
            data: data,
        })
    },
    submitSupplier: (data) => {
        return request({
            url: 'potentialSupplier/submitPotentialSupplier',
            method: 'post',
            data: data,
        })
    },
    //获取地区
    getArea: (data) => {
        return request({
            url: 'area/getAreaList',
            method: 'post',
            data: data,
        })
    },
    //供应商资源列表查询
    getResourceList: (data) => {
        return request({
            url: 'supplierResource/searchSupplierResource',
            method: 'post',
            data: data,
        })
    },
    //资源详情
    // potentialSupplierDetail: (tmSupplierId) => {
    //     return request({
    //         url: `supplierResource/supplierResourceDetail/${tmSupplierId}`,
    //         method: 'GET',
    //     })
    // },
    saveResource: (data) => {
        return request({
            url: 'supplierResource/saveSupplierResource',
            method: 'post',
            data: data,
        })
    },
    submitResource: (data) => {
        return request({
            url: 'supplierResource/submitSupplierResource',
            method: 'post',
            data: data,
        })
    },
    //供应商工厂列表查询
    searchGroupPlant: (data) => {
        return request({
            url: 'supplierResource/searchGroupPlant',
            method: 'post',
            data: data,
        })
    },
    getMyPlantList: () => {
        return request({
            url: 'supplierResource/myPlantList',
            method: 'get',
        })
    },
    //供应商Category列表
    getGroupCategoryList: (id) => {
        return request({
            url: 'supplierResource/getGroupCategoryList/' + id,
            method: 'get',
        })
    },
    approval: (data) => request({
        url: `potentialSupplier/approvePotentialSupplier`,
        method: 'post',
        data: data
    }),
    //更新供应商附件操作日志
    UpdateDocument: (data) => request({
        url: `potentialSupplier/updateSupplierDocumentLog`,
        method: 'post',
        data: data
    }),
    //供应商资源审批
    approvalResource: (data) => request({
        url: `supplierResource/approveSupplierResource`,
        method: 'post',
        data: data
    }),
    //转正式供应商
    changeFormal: (tmSupplierId) => request({
        url: `potentialSupplier/updatePotentialSupplierStatus`,
        method: 'post',
        data: { 'tmSupplierId': tmSupplierId }
    }),


}